import { Store, Module, ActionContext } from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations'
import BackMainLandOrderList from '../entities/order-back-list'
import createdata from '@/store/entities/create-order'
import UpdateBackMainLandOrderStatu from '@/store/entities/back-order-update-statu'
import ResultModel from '@/store/entities/nationalLogisticsInfo'
import appconst from '@/lib/appconst';
interface BackMainLandOrderState extends ListState<BackMainLandOrderList> {
    orderInfo: createdata,
    updateOrdeData: UpdateBackMainLandOrderStatu,
}

class BackMainLandOrderMutations extends ListMutations<BackMainLandOrderList>{

}
class BackMainLandOrder extends ListModule<BackMainLandOrderState, any, BackMainLandOrderList>{
    state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<BackMainLandOrderList>(),
        loading: false,
        updateOrdeData: null,
        ids: [],
        ordertype: 1,
        id: 0,
        packageName: "",
        cargoCategory: 0,
        BaseSkuNums: 0,
        isPacked: false,
        orderNumber: "",
        automaticJump: true,
        tradeNo: ""
    }
    actions = {
        async getAll(context: ActionContext<BackMainLandOrderState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/services/app/BackOrder/GetOrderList', { params: payload.data });
            context.state.loading = false;
            let page = reponse.data.result as PageResult<BackMainLandOrderList>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        },
        async getOrder(context: ActionContext<BackMainLandOrderState, any>, payload: any) {
            let reponse = await Ajax.get('/api/services/app/BackOrder/GetOrderInfo', { params: payload.data });
            context.state.orderInfo = (reponse.data.result as createdata);
        },
        async getSearchPackedOrder(context: ActionContext<BackMainLandOrderState, any>, payload: any) {
            let reponse = await Ajax.get('/api/services/app/BackOrder/GetSearchOrderList?tradeNo=' + payload.data.tradeNo);
            return reponse.data.result as BackMainLandOrderList;
        },
        async updateOrderStatus(context: ActionContext<BackMainLandOrderState, any>, payload: any) {
            let rep = await Ajax.post('/api/services/app/BackOrder/ProcesOrderStatu', payload.data);
        },
        async cancelOrder(state: any, payload: any) {
            let rep = await Ajax.post('/api/services/app/BackOrder/CancelOrder?id=' + payload.data.id);
        },
        async updatePackageStatus(state: any, payload: any) {
            let rep = await Ajax.post('/api/services/app/BackOrder/ProcessOrderPackageStatus', payload.data);
        },
        async arriveWarehouse(state: any, payload: any) {
            let rep = await Ajax.post('/api/services/app/BackOrder/arriveWarehouse?tradeNo=' + payload.data.tradeNo);
        },
        async commodityWeigh(state: any, payload: any) {
            let rep = await Ajax.post('/api/services/app/BackOrder/CommodityWeigh?tradeNo=' + payload.data.tradeNo + '&resultWeight=' + payload.data.resultWeight);
        },
        async goodsInfoAdd(state: any, payload: any) {
            let rep = await Ajax.post('/api/services/app/BackOrder/GoodsWeigh', payload.data);
            return rep.data.result;
        },
        async editShipment(state: any, payload: any) {
            let rep = await Ajax.post('/api/services/app/BackOrder/EditInterNationalShipment?id=' + payload.data.id + '&mainLandPackageId=' + payload.data.mainLandPackageId);
        },
        async getResult(state: any, payload: any) {
            let rep = await Ajax.post('/api/services/app/FrontOrder/GetSearchResult?number=' + payload.data.number);
            return rep.data.result as ResultModel;
        },
        async getOrderWeighingInfo(state: any, payload: any) {
            let rep = await Ajax.get('/api/services/app/BackOrder/GetOrderWeighingInfo?orderId=' + payload.data.orderId);
            return rep.data.result;
        },
        async saveSingleWeighingInfo(state: any, payload: any) {
            let rep = await Ajax.post('/api/services/app/BackOrder/SaveSingleWeighingInfo', payload.data);
        },
        async impotExcel(state: any, payload: any) {
            Ajax.get('/api/File/GetExpressExportMainlandOrderInfo', { params: payload.data, responseType: "blob" }).then(res => {
                const content = res.data;
                const blob = new Blob([content]);
                const fileName = '本土订单信息.xlsx'
                if ('download' in document.createElement('a')) { // 非IE下载
                    const elink = document.createElement('a')
                    elink.download = fileName
                    elink.style.display = 'none'
                    elink.href = URL.createObjectURL(blob)
                    document.body.appendChild(elink)
                    elink.click()
                    URL.revokeObjectURL(elink.href) // 释放URL 对象
                    document.body.removeChild(elink)
                }
            });
        },
        async setTakePicture(state: any, payload: any) {
            let rep = await Ajax.post('/api/services/app/BackOrder/SetTakePicture', payload.data);
            return rep.data.result;
        },
        async uploadpackedImg(state: any, payload: any) {
            let rep = await Ajax.post('/api/services/app/BackOrder/UploadPackedBase64Img', payload.data);
            return rep.data.result;
        },
        async setTakePictureAbnormal(state: any, payload: any) {
            let rep = await Ajax.post('/api/services/app/BackOrder/SetTakePictureAbnormal', payload.data);
            return rep.data.result;
        },
        async GetCheckGoodsInfoResult(state: any, payload: any) {
            let rep = await Ajax.get('/api/services/app/BackOrder/GetCheckGoodsInfoResult?tradeNo=' + payload.data.tradeNo);
            return rep.data.result;
        },
        async getLogisticsTrack(context: ActionContext<BackMainLandOrderState, any>, payload: any) {
            let rep = await Ajax.get('/api/services/app/BackMainLandPackage/GetLogisticsTrack', {
                params: {
                    orderId: payload.orderId,
                    number: payload.number
                }
            });
            return rep.data.result; // 直接返回result，由统一拦截器处理异常
        },

    };
    mutations = {
        setCurrentPage(state: BackMainLandOrderState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: BackMainLandOrderState, pagesize: number) {
            state.pageSize = pagesize;
        },
        getImgUrl(state: BackMainLandOrderState, data: any) {
            if (data.imageGuid && data.imageGuid.length > 1) {
                data.url = appconst.remoteServiceBaseUrl + "api/File/GetPackedImage?guid=" + data.imageGuid;
            } else {
                data.url = null;
            }
        },
    }
}

const backmainlandorder = new BackMainLandOrder();
export default backmainlandorder;